import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function RequireAuth({ children, adminOnly = false }) {
  const { role } = useAuth();
  const location = useLocation();
  const [isHydrated, setIsHydrated] = useState(false);

  // Give auth state a moment to hydrate from localStorage
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // While hydrating, show nothing (prevents flash of redirect)
  if (!isHydrated) {
    return null;
  }

  if (!role) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (adminOnly && role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
